// extracted by mini-css-extract-plugin
export default {"title__select":"DoughnutBoxTitleWithComparator_title__select__TpDBO"};